"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSuggestionsApiVersion = function (apiVersion) { return ({
    type: "SET_SUGGESTIONS_APIVERSION",
    apiVersion: apiVersion
}); };
exports.setSuggestionsParameters = function (parameters) { return ({
    type: "SET_SUGGESTIONS_PARAMETERS",
    parameters: parameters
}); };
exports.updateSuggestionsParameters = function (parameters) { return ({
    type: "UPDATE_SUGGESTIONS_PARAMETERS",
    parameters: parameters
}); };
//# sourceMappingURL=suggestionsParametersActions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/azsearchstore/dist/actions/suggestionsParametersActions.js
// module id = 55
// module chunks = 0